import { Outlet } from 'react-router';
import { ThemeProvider } from 'styled-components';

import { ErrorBoundary } from '#/containers/ErrorBoundary';
import { ModalRoot } from '#/containers/Modal/ModalRoot';
import { SetFlashMessages } from '#/containers/SetFlashMessages';
import { SetGMapsError } from '#/containers/SetGMapsError';
import { TabContextProvider } from '#/containers/TabContext';
import { TemporaryStorageContextProvider } from '#/containers/TemporaryStorageContext';
import { ToastsContainer } from '#/containers/ToastsContainer';
import { SearchContextProvider } from '#/modules/search/contexts/SearchContext';
import { themeContextValue } from '#/theme/theme';

import { GlobalHandlers } from './global-handlers/GlobalHandlers';

export function App() {
  return (
    <ThemeProvider theme={themeContextValue}>
      <ErrorBoundary>
        <SearchContextProvider>
          <GlobalHandlers />
          <SetGMapsError />
          <SetFlashMessages />
          <TemporaryStorageContextProvider>
            <TabContextProvider>
              <ModalRoot />
              <ToastsContainer />
              <Outlet />
            </TabContextProvider>
          </TemporaryStorageContextProvider>
        </SearchContextProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}
